export const DIPLOMAS = [
  { id: '235', name: '23/5-regelen' },
  { id: '235YRK', name: '23/5-regelen med YRK' },
  { id: 'SSREAL', name: 'Stud.spes. realfag' },
  { id: 'SSSAMF', name: 'Stud.spes. samfunnsfag' },
  { id: 'IL', name: 'Idrettslinje' },
  { id: 'MK', name: 'Medier & Kommunikasjon' },
  { id: 'MUS', name: 'Musikk, dans og drama' },
  { id: 'ED', name: 'Elektro og datateknologi' },
  { id: 'FBIE', name: 'Frisør, blomster, interiør og eksponeringsdesign' },
  { id: 'IM', name: 'Informasjonsteknologi og medieproduksjon' },
  { id: 'HO', name: 'Helse og oppvekstfag' },
  { id: 'SSR', name: 'Salg, service og reiseliv' },
  { id: 'YRK', name: 'Andre yrkesfag' },
] as const

export type DiplomaType = (typeof DIPLOMAS)[number]
export type DiplomaIdType = DiplomaType['id']

export const SESSION_STORAGE_UUID_KEY = 'calculator-uuid'
